import _createRedux from "lib/createRedux";

import actions from "./actions/index";
import reducers from "./reducers/index";

export {connect, Provider} from "react-redux";

export default function createRedux(...middleware) {
    return _createRedux(reducers, actions, ...middleware);
}


// WEBPACK FOOTER //
// ./src/kpi/store/index.js